import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Col, Divider, Form, Input, Row, Select, TimePicker, Typography } from 'antd';
import { CircleX } from 'lucide-react';
import { getRoutes } from '../../../routes/Routes';
import { addLead } from '../../../redux/actions/leads';

const AddLead = () => {
    const [form] = Form.useForm();

    const handleSubmit = async (values) => {
        console.log('Submitted:', values);
        const body = {
            ...values,
            opening_hours: values.opening_hours ? values.opening_hours.format('HH:mm') : null,
            closing_hours: values.closing_hours ? values.closing_hours.format('HH:mm') : null,
        }
        const res = await addLead(body);
        console.log('Response:', res);
    };

    return (
        <div className="add-lead-page">
            <div className="page-header mb-3">
                <div className="flex justify-content-between align-items-center mb-2">
                    <Typography.Title level={3} className="page-title">
                        Add Lead
                    </Typography.Title>
                </div>
            </div>

            <Form
                form={form}
                layout="vertical"
                size="large"
                className="tight-form"
                onFinish={handleSubmit}
            >
                <Card variant="borderless" className="p-0 border-round-2xl shadow-1">
                    <Row gutter={16}>
                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Name"
                                name="name"
                                rules={[{ required: true, message: 'Please enter name' }]}
                            >
                                <Input placeholder="Name" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    { required: true, message: 'Please enter email' },
                                    { type: 'email', message: 'Invalid email address' },
                                ]}
                            >
                                <Input placeholder="Email" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Phone"
                                name="phone"
                                rules={[{ required: true, message: 'Please enter phone' }]}
                            >
                                <Input placeholder="Phone" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item label="Whatsapp" name="whatsapp">
                                <Input placeholder="Whatsapp" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item label="Terms" name="terms">
                                <Select
                                    placeholder="Terms"
                                    options={[
                                        {
                                            label: 'Account',
                                            value: 'account',
                                        },
                                        {
                                            label: 'Cash on Delivery',
                                            value: 'cod',
                                        },
                                    ]}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item label="Business Types" name="business_types">
                                <Select
                                    placeholder="Business Types"
                                    mode="multiple"
                                    options={[
                                        { label: 'Retail', value: 'retail' },
                                        { label: 'Wholesale', value: 'wholesale' },
                                        { label: 'Manufacturing', value: 'manufacturing' },
                                        { label: 'Service', value: 'service' },
                                    ]}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item label="Opening Hours" name="opening_hours">
                                <TimePicker format="HH:mm" minuteStep={5} showNow={false} className="w-full" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item label="Closing Hours" name="closing_hours">
                                <TimePicker format="HH:mm" minuteStep={5} showNow={false} className="w-full" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>

                {/* Addresses Section */}
                <Divider orientation="left" orientationMargin={0} className="my-3">
                    Addresses
                </Divider>

                <Form.List name="addresses">
                    {(fields, { add, remove }, { errors }) => (
                        <>
                            {fields.map((field, index) => (
                                <Card
                                    key={field.key}
                                    variant="borderless"
                                    className="p-0 border-round-2xl shadow-1 my-3"
                                    title={`Address ${index + 1}`}
                                    extra={
                                        fields.length > 1 && <CircleX onClick={() => remove(field.name)} size={20} />
                                    }
                                >
                                    <Row gutter={16}>
                                        <Col xs={24} md={12}>
                                            <Form.Item
                                                label="Address Line 1"
                                                name={[field.name, 'address_1']}
                                                rules={[{ required: true, message: 'Please enter address line 1' }]}
                                            >
                                                <Input placeholder="Address Line 1" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={12}>
                                            <Form.Item label="Address Line 2" name={[field.name, 'address_2']}>
                                                <Input placeholder="Address Line 2" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={12}>
                                            <Form.Item label="City" name={[field.name, 'city']}>
                                                <Input placeholder="City" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={12}>
                                            <Form.Item label="Postcode" name={[field.name, 'postcode']}>
                                                <Input placeholder="Postcode" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            ))}

                            <Button
                                variant="dashed"
                                color="primary"
                                onClick={() => add()}
                                block
                                icon={<PlusOutlined />}
                            >
                                Add Address
                            </Button>
                        </>
                    )}
                </Form.List>
            </Form>

            <div className="flex justify-content-end align-items-center gap-2 mt-4">
                <Button htmlType="button" href={getRoutes().leads.route()} size="large">
                    Cancel
                </Button>
                <Button type="primary" htmlType="submit" size="large" onClick={() => form.submit()}>
                    Submit
                </Button>
            </div>
        </div>
    );
};

export default AddLead;
